import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import { superstyled } from '@zenbusiness/zui/styles';

export const HelpSectionActions = superstyled({
  name: 'HelpSection',
  slot: 'Actions',
  tag: Card,
  propsAdded: {
    component: 'ul',
  },
});

export const HelpSectionActionItem = superstyled({
  name: 'HelpSection',
  slot: 'ActionItem',
  tag: Box,
  propsAdded: {
    component: 'li',
  },
  styles: ({ theme }) => ({
    '&:not(:first-child)': {
      borderTop: `1px solid ${theme.palette.divider}`,
    },
  }),
});
